import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-question-number',
  templateUrl: './question-number.component.html',
  styleUrls: ['./question-number.component.css']
})
export class QuestionNumberComponent implements OnInit {

  @Input('rowData') rowData;
  constructor() { }

  ngOnInit() {
  }

}
